var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditClearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 2.00053C12.0081 1.82543 12.216 1.68654 12.4447 1.59178C12.6735 1.49702 12.9187 1.44824 13.1663 1.44824C13.414 1.44824 13.6592 1.49702 13.8879 1.59178C14.1167 1.68654 14.3246 1.82543 14.4997 2.00053C14.6748 2.17562 14.8137 2.38349 14.9084 2.61227C15.0032 2.84104 15.052 3.08624 15.052 3.33386C15.052 3.58148 15.0032 3.82668 14.9084 4.05546C14.8137 4.28423 14.6748 4.4921 14.4997 4.66719L5.49967 13.6672L1.83301 14.6672L2.83301 11.0005L11.833 2.00053Z",
    stroke: "#1B51A4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditClearIcon);
export default __webpack_public_path__ + "static/media/edit-clear-icon.47bb03c47ada7471c09e1f243f8d7d3d.svg";
export { ForwardRef as ReactComponent };